import axios from "axios";
import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import Book from "./pages/Book";
import Interior from "./pages/services/Interior";
import FullDetailing from "./pages/services/FullDetailing";
import PaintCorrection from "./pages/services/PaintCorrection";
import Ceramic from "./pages/services/Ceramic";
import MarineAviation from "./pages/services/MarineAviation";
import Tinting from "./pages/services/Tinting";
import ResComTint from "./pages/services/ResComTint";
import PPF from "./pages/services/PPF";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ink text-white px-6">
          <div className="text-center">
            <p className="font-display text-2xl font-bold">Something went wrong.</p>
            <p className="mt-3 text-steel">Please refresh the page or call us at 605-799-5882.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <SmoothScroll />
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/book" element={<Book />} />
              <Route path="/interior-detailing" element={<Interior />} />
              <Route path="/full-detailing" element={<FullDetailing />} />
              <Route path="/paint-correction" element={<PaintCorrection />} />
              <Route path="/ceramic-coatings" element={<Ceramic />} />
              <Route path="/marine-aviation-ceramic" element={<MarineAviation />} />
              <Route path="/window-tinting" element={<Tinting />} />
              <Route path="/residential-commercial-tinting" element={<ResComTint />} />
              <Route path="/paint-protection-film" element={<PPF />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <Toaster theme="dark" position="bottom-center" />
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
